import React from 'react';
import { makeClassName } from '@siteless/util';

const ClipboardIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('ClipboardIcon', className)}
  >
    <path
      d="M18,23H6c-1.65,0-3-1.35-3-3V6c0-1.65,1.35-3,3-3h2c0.55,0,1,0.45,1,1S8.55,5,8,5H6C5.45,5,5,5.45,5,6v14c0,0.55,0.45,1,1,1
	h12c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-2c-0.55,0-1-0.45-1-1s0.45-1,1-1h2c1.65,0,3,1.35,3,3v14C21,21.65,19.65,23,18,23z"
    />
    <path d="M15,7H9C7.9,7,7,6.1,7,5V3c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v2C17,6.1,16.1,7,15,7z M9,3L9,3v2h6V3H9z" />
  </svg>
);

export default ClipboardIcon;
